module.exports = __webpack_public_path__ + "media/brands/mclaren-8239b9c3.png";